
/**
 * CreateSubcontaSimplificadoUseCase
 */
import { SubcontaSimplificadoForm } from "../../../presentation/schemas/SubContaSimplificado";
import { ICreateSubcontaSimplificadoUseCase } from "../../../presentation/useCases/create/create_subconta_simplificado_use_case";
import { ICommonsRepository } from "../../repositories/commons_repository";

export class CreateSubcontaSimplificadoUseCase implements ICreateSubcontaSimplificadoUseCase {
  constructor(private readonly repository: ICommonsRepository) { }

  async createSubcontaSimplificado(form: SubcontaSimplificadoForm): Promise<number> {
    return this.repository.createSubcontaSimplificado(form);
  }
}
